import { render, staticRenderFns } from "./AnalyticsApp.vue?vue&type=template&id=4fb5f1d2&"
import script from "./AnalyticsApp.vue?vue&type=script&setup=true&lang=js&"
export * from "./AnalyticsApp.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports